import { Component, OnInit } from '@angular/core';
import {BreadcrumbMain, BreadcrumbPayroll, BreadcrumbSolutionMgr, BreadcrumbSolutionMgrTransactionDataImport, RouteLink} from '@app/shared';
import {MenuItem} from "primeng/api";

@Component({
  selector: 'app-transaction-data-import',
  templateUrl: './transaction-data-import.component.html',
  styleUrls: ['./transaction-data-import.component.css']
})
export class TransactionDataImportComponent implements OnInit {

  RouteLink: typeof RouteLink = RouteLink;
  public breadcrumb: MenuItem[] = [];

  constructor() { }

  ngOnInit(): void {
    this.breadcrumb.push(BreadcrumbMain);
    this.breadcrumb.push({ label: 'Data Import Main', routerLink: '' });
  }

}
